"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityActivitiesDto = exports.OpportunityActivityDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
class OpportunityActivityDto {
}
exports.OpportunityActivityDto = OpportunityActivityDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the opportunity activity",
        example: 101,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity activity ID is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Opportunity activity ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Due date for the activity",
        example: "2025-05-10",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Due Date is required" }),
    (0, class_validator_1.IsDateString)({}, { message: "Due Date must be a valid ISO date" }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Participants of the given activity",
        example: [1, 2],
    }),
    (0, class_validator_1.IsArray)({ message: "Participants must be an array of valid users" }),
    tslib_1.__metadata("design:type", Array)
], OpportunityActivityDto.prototype, "participants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Owner of the activity",
        example: 5,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Owner ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityDto.prototype, "ownerId", void 0);
class OpportunityActivitiesDto {
}
exports.OpportunityActivitiesDto = OpportunityActivitiesDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of opportunity activities",
        type: [OpportunityActivityDto],
    }),
    (0, class_validator_1.IsArray)({ message: "Opportunity activities must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => OpportunityActivityDto),
    tslib_1.__metadata("design:type", Array)
], OpportunityActivitiesDto.prototype, "opportunityActivities", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivitiesDto.prototype, "updatedBy", void 0);
